export default {
  'A': ['A4', 'C4', 'E4', 'A5', 'C5', 'E5'],
  'B': ['B4', 'D4', 'F4', 'B5', 'D5', 'F5'],
  'C': ['C4', 'E4', 'G4', 'C5', 'E5', 'G5'],
  'Cm': ['C4', 'D#4', 'A4', 'C5', 'D#5', 'A5'],
  'CmLow': ['C3', 'D#3', 'A3', 'C4', 'D#4', 'A4'],
  'D': ['D4', 'G5', 'B5', 'D5', 'G6', 'B6'],
  'E': ['E4', 'G5', 'B5', 'E5', 'G6', 'B6'],
  'F': ['F4', 'A5', 'C5', 'F5', 'A6', 'C6'],
  'Fm': ['C4', 'F4', 'G#4', 'C5', 'F5', 'G#5'],
  'G': ['G4', 'B5', 'D5', 'G5', 'B6', 'D6'],
  'hexatonic': ['G4', 'G#4', 'F#4', 'C4', 'D#4', 'F4'],
};
